import { format, parse } from "date-fns";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { withTranslation, useTranslation } from "react-i18next";
import Modal from "react-modal";
import { connect } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import { compose } from "recompose";
import placeholderImg from "../../../../../assets/img/gallery/placeholder.jpg";
import { GET_PHOTOS_RELATED } from "../../../../../services/redux/photos/actions";
import {
  clearRelatedPhotos,
  getPhotos,
} from "../../../../../services/redux/photos/reducer";
import { selectRelatedPhotos } from "../../../../../services/redux/photos/selectors";
import { ReactComponent as XIcon } from "../../../../svg-icons/x.svg";
import LoginForm from "../../../LoginForm/LoginForm";
import ShareButtons from "../../../Share/ShareButtons";
import Tag from "../../../Tag/Tag";
import "./PhotoModal.scss";
import VoteWithoutAuth, {
  hasPhotoVoted, userIsLogin,
} from "../VoteWithoutAuth/VoteWithoutAuth";
import Image from "../../../Image/Image";
import { LikeIcon } from "../../ShowOffField";
import { getAuthorNameOfPhoto } from "../../helpers";
import {
  voteOnPhoto,
  unvoteOnPhoto,
} from "../../../../../services/redux/photos/reducer";
import { VoteWithoutAuthModal } from "../../VoteWithoutAuthModal/VoteWithoutAuthModal";
import RelatedGallery from "../../relatedGallery";

const PhotoModal = ({
  isOpen,
  onRequestClose,
  selected,
  relatedPhotos,
  getPhotos,
  clearRelatedPhotos,
  voteOnPhoto,
  unvoteOnPhoto,
  showLogin,
  setShowLogin,
  setSelected,
  setPhotoToLike,
  photoToLike,
  latest,
  setLatest,
  selectedPopupVisible,
  setSelectedPopupVisible,
}) => {
  const { t } = useTranslation(["widgets"]);
  const userLoggedIn = userIsLogin();
  const [related, setRelated] = useState([]);

  const voteOnSelectedPhoto = ({ slug, voted }) => {
    if (!userLoggedIn) {
      setPhotoToLike({ ...selected });
      setShowLogin(true);
      return;
    }

    if (voted) {
      unvoteOnPhoto({ slug });
    } else {
      voteOnPhoto({ slug });
    }

    let newSelected = {
      ...selected,
      voted: !voted,
      votes_count: voted
        ? selected.votes_count - 1
        : selected.votes_count + 1,
    };
    setSelected(newSelected);

    let index = latest.findIndex((item) => item.slug === selected.slug);
    if (index !== -1) {
      let newLatest = [...latest];
      newLatest[index] = {
        ...newLatest[index],
        voted: !newLatest[index].voted,
        votes_count: newLatest[index].voted
        ? newLatest[index].votes_count - 1
        : newLatest[index].votes_count + 1,
      };
      setLatest(newLatest);
    }
  };

  const voteOnRelatedPhoto = (photo, index) => {
    if (!userLoggedIn) {
      setPhotoToLike({ ...photo });
      setShowLogin(true);
      return;
    }

    if (!!photo.voted) {
      unvoteOnPhoto({ slug: photo.slug });
    } else {
      voteOnPhoto({ slug: photo.slug });
    }

    let newRelated = [...related];
    newRelated[index] = {
      ...newRelated[index],
      voted: !newRelated[index].voted,
      votes_count: newRelated[index].voted
        ? newRelated[index].votes_count - 1
        : newRelated[index].votes_count + 1,
    };
    setRelated(newRelated);
  };

  const voteAsGuestOnPhotoToLike = ({ slug, voted }) => {
    if (voted) {
      unvoteOnPhoto({ slug });
    } else {
      voteOnPhoto({ slug });
    }

    const newSelected = {
      ...photoToLike,
      voted: !voted,
      votes_count: voted
        ? photoToLike.votes_count - 1
        : photoToLike.votes_count + 1,
    };
    setSelected(newSelected);
  };

  useEffect(() => {
    if (!!relatedPhotos && relatedPhotos.results.length > 0) {
      setRelated(relatedPhotos.results);
    }
  }, [relatedPhotos])

  useEffect(() => {
    if (selected !== null) {
      getPhotos({
        params: {
          owner__slug: selected.owner.slug,
          publish_status: "2",
        },
        type: GET_PHOTOS_RELATED,
      });
    } else {
      clearRelatedPhotos();
    }
  }, [selected]);

  useEffect(() => {
    if (showLogin) {
      document.querySelector("body").style.overflowY = "hidden";
    } else {
      document.querySelector("body").style.overflowY = "scroll";
    }
  }, [showLogin]);

  const getRewardMeta = reward => {
    const year = format(parse(reward.created_at), "YYYY");
    if (reward.period === 1) {
      return `${t(`calculatorPage:months.${reward.order_number - 1}`)} ${year}`;
    }
    if (reward.period === 2) {
      return `${reward.order_number} ${t("widgets:common.quarter")} ${year}`;
    }
    return null;
  };

  return (
    <>
      <Modal
        isOpen={selectedPopupVisible}
        onRequestClose={() => {
          onRequestClose()
          setSelectedPopupVisible(false)
        }}
        style={{
          overlay: {
            zIndex: "1000",
            backgroundColor: "rgba(0,0,0,0.6)",
            overflowY: "scroll",
          },
          content: {
            width: "100%",
            maxWidth: "1170px",
            margin: "0 auto 40px auto",
            bottom: "unset",
            borderRadius: 0,
            padding: 0,
            overflowX: "hidden",
            backgroundColor: "#f1f1f1",
          },
        }}
      >
        <Container fluid className="c-photo-modal">
          {isOpen && (
            <Row className="c-photo-modal__row">
              <Col xs={12} sm={6} className="c-photo-modal__image">
                <div style={{ position: "relative", width: "100%" }}>
                  <Image
                    src={
                      selected.publish_status === 3 ? placeholderImg : selected.image
                    }
                    alt=""
                  />
                  {selected.rewards.length > 0 && (
                    <div className="c-photo-modal__rewarded">
                      {t("widgets:photo.rewarded")}
                    </div>
                  )}
                </div>
              </Col>
              <Col xs={12} sm={6} className="c-photo-modal__content">
                <h3>{selected.title}</h3>
                <div className="c-photo-modal__tags">
                  {selected.tags.slice(0, 4).map(({ name }) => (
                    <Tag key={`${selected.title}-${name}`} label={name} />
                  ))}
                  {selected.tags.length > 4 && (
                    <span className="c-photo-modal__tags__more">
                      + {selected.tags.length - 4} {t("widgets:photo.moreTags")}
                    </span>
                  )}
                </div>
                <Row>
                  <Col sm={8}>
                    <a
                      className="c-photo-modal__author"
                      href={`/galeria/${selected.owner.slug}`}
                    >
                      <span>{t("widgets:photo.author")}:</span>{" "}
                      {getAuthorNameOfPhoto(selected)}
                    </a>
                    <p className="c-photo-modal__author">
                      <span>{t("widgets:photo.date")}:</span>{" "}
                      {format(selected.published_at, "DD.MM.YYYY")}
                    </p>
                  </Col>
                  {selected.publish_status === 2 && (
                    <Col sm={4} className="c-photo-modal__rating">
                      <span>{selected.votes_count}</span>
                      <LikeIcon
                        isLiked={hasPhotoVoted(selected, userLoggedIn)}
                        onClick={() => voteOnSelectedPhoto({
                          slug: selected.slug,
                          voted: hasPhotoVoted(selected, userLoggedIn),
                        })}
                      />
                    </Col>
                  )}
                </Row>
                {selected.rewards.length > 0 && (
                  <Col xs={12} className="c-photo-modal__content__rewarded">
                    <h2>{t("widgets:photo.awardedFor")}:</h2>
                    <div>
                      {selected.rewards.map(reward => (
                        <div
                          key={`${reward.order_number}-${reward.period}`}
                          className="c-photo-modal__reward">
                          {t("widgets:photo.bestPicture")}:{" "}
                          {getRewardMeta(reward)}
                        </div>
                      ))}
                    </div>
                  </Col>
                )}

                {selected.publish_status === 2 && (
                  <div className="c-photo-modal__share">
                    <ShareButtons
                      shareUrl={`${window.location.origin}/galeria?slug=${selected.slug
                        }`}
                    />
                  </div>
                )}
              </Col>
              <Col xs={12} className="c-photo-modal__related">
                <h2>{t("widgets:photo.linked")}:</h2>
              </Col>
              <Col xs={12}>
                <RelatedGallery
                  key={`${selected.id}-related`}
                  photos={
                    related.filter(
                      photo => photo.id !== selected.id
                    )
                  }
                  onClick={(photo) => {
                    document
                      .querySelector(".ReactModal__Content")
                      .scrollTo(0, 0);
                    setSelected(photo);
                  }}
                  voteOnRelatedPhoto={voteOnRelatedPhoto}
                />
              </Col>
              <button
                type="button"
                className="c-photo-modal__close"
                onClick={() => {
                  onRequestClose()
                  setSelectedPopupVisible(false)
                }}
              >
                <XIcon />
              </button>
            </Row>
          )}
        </Container>
      </Modal>

      <VoteWithoutAuthModal
        showLogin={showLogin}
        setShowLogin={setShowLogin}
        onVoteClick={() => voteAsGuestOnPhotoToLike({
          slug: photoToLike.slug,
          voted: photoToLike.voted,
        })}
        selectedPhoto={photoToLike}
        onVoteCallback={() => { setShowLogin(false) }}
      />
    </>
  );
};

PhotoModal.propTypes = {};
PhotoModal.defaultProps = {};

export default compose(
  withTranslation(["calculatorPage", "widgets"]),
  connect(
    state => ({
      relatedPhotos: selectRelatedPhotos(state),
    }),
    {
      getPhotos,
      clearRelatedPhotos,
      voteOnPhoto,
      unvoteOnPhoto,
    }
  )
)(PhotoModal);
